import store from '@/store/index.ts';
import Element, { ElementType } from '../element';
import { stringUtil } from '../stringUtil';
import { AddWallsCommand } from './addWallsCommand';
import { AddHandlesToFrontCommand } from './addHandlesToFrontCommand';
import { AddFrontsToDrawerCommand } from './addFrontsToDrawerCommand';
import { BaseCommand } from './baseCommand';
import { AddHingesToFrontCommand } from './addHingesToFrontCommand';
import { ElementMenuItem } from '../elementMenuItem';
import { SlotItem } from '../slotItem';
import { Vector2 } from '@babylonjs/core';
import { RemoveSeparatingWallCommand } from './removeSeparatingWallCommand';

export default class AddElementCommand extends BaseCommand {

    private element!: ElementMenuItem;
    private slot!: SlotItem;

    public constructor(
        scenePreview: any
    ) {
        super(scenePreview);
    }

    public execute(): void {
        if (!this.element && !this.slot) {
            this.element = store.getters.scene.selectedElementMenuItem;
            this.slot = this.scenePreview.$store.getters.scene.slotItem;
        }
        if (!this.element) { return; }
        if (!this.element.subElements.length) {
            this.addElement(this.element, this.slot, this.slot.position);
        } else {
            const result: Element[] = [];
            this.element.subElements.forEach((elem, index) => {
                const position = this.slot.position.add(new Vector2(Math.pow(-1, index) * elem.shape.x / 2, 0));
                // const slot = new SlotItem(
                //     this.slot.url,
                //     position,
                //     new Vector2(this.slot.shape.x / 2, this.slot.shape.y),
                // );
                this.addElement(elem, this.slot, position, (x) => {
                    result.forEach((r) => x.bind(r));
                    result.push(x);
                });
            });
        }
    }

    private addElement(
        element: ElementMenuItem,
        slot: SlotItem,
        position: Vector2,
        callback: (x: Element) => void = () => { },
    ) {
        const model = stringUtil.fillTemplate(element.model, slot);
        const light = stringUtil.fillTemplate(element.light, slot);
        const shader = store.getters.shaderFor(element);
        const shape = element.shape;
        this.scenePreview.addElement(model, light, shader, position, shape, (x: Element) => {
            x.menuElement = element;
            x.slot = slot;
            this.elements.push(x);
            this.createWalls(x);
            if (x.isDrawer) {
                this.createFrontsForDrawer(x);
            }
            if (x.type === ElementType.FRONT) {
                this.createAdditionalElementsForFront(x);
            }
            callback(x);
        });
    }

    private createWalls(element: Element) {
        const command = new AddWallsCommand(element, this.scenePreview);
        this.addCommand(command);
    }

    private createFrontsForDrawer(drawer: Element) {
        const command = new AddFrontsToDrawerCommand(drawer, this.scenePreview, () => {
            this.removeSeparatingWall(drawer);
        });
        this.addCommand(command);
    }

    private removeSeparatingWall(drawer: Element) {
        const command = new RemoveSeparatingWallCommand(drawer, this.scenePreview);
        this.addCommand(command);
    }

    private createAdditionalElementsForFront(front: Element) {
        this.createHandleForFront(front);
        this.createHingeForFront(front);
    }

    private createHandleForFront(front: Element) {
        const command = new AddHandlesToFrontCommand(front, this.scenePreview);
        this.addCommand(command);
    }

    private createHingeForFront(front: Element) {
        const command = new AddHingesToFrontCommand(front, this.scenePreview);
        this.addCommand(command);
    }
}
